import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomHttpClientService } from './custom-http-client.service';

@Injectable()
export class CommentService {

  private url = environment.apiUrl;
  id = localStorage.getItem('residents');

  constructor(private http: CustomHttpClientService) {}

  saveComment(commentData: any, type: any): Observable<any> {
    return this.http.post(`${this.url}comment/save`, { commentData, feedType: type })
      .pipe(catchError(this.handleError));
  }






  getCommentsByActivityFeed(id: any, userId: any): Observable<any> {
    return this.http.get(`${this.url}user/${userId}/comment/get/${id}`)
      .pipe(catchError(this.handleError));
  }

  getAllCommentsByActivityFeed(id: any, userId: any): Observable<any> {
    return this.http.get(`${this.url}posts/${id}/comments/user/${userId}`)
      .pipe(catchError(this.handleError));
  }

  getLatestCommentsByActivityId(feedId: any, userId: any, diff: any): Observable<any> {
    return this.http.get(`${this.url}user/${userId}/activity/${feedId}/diff/${diff}`)
      .pipe(catchError(this.handleError));
  }


 










  updateComment(commentData: any, feedType: any): Observable<any> {
    return this.http.put(`${this.url}comment/update/`, { commentData, type: feedType })
      .pipe(catchError(this.handleError));
  }

  deleteComment(id: any, type: any, userId: any, postId: any, isManager: any): Observable<any> {
    return this.http.delete(`${this.url}comment/delete/?id=${id}&type=${type}&userId=${userId}&postId=${postId}&isManager=${isManager}`)
      .pipe(catchError(this.handleError));
  }

  saveReply(replyData: any, type: any): Observable<any> {
    return this.http.post(`${this.url}reply/save`, { replyData, feedType: type })
      .pipe(catchError(this.handleError));
  }

  getAllRepliesByComment(id: any): Observable<any> {
    return this.http.get(`${this.url}comment/${id}/replies`)
      .pipe(catchError(this.handleError));
  }

  getRepliesByComment(id: any, skip: number, limit: number): Observable<any> {
    return this.http.get(`${this.url}reply/get/${id}/start/${skip}/load/${limit}`)
      .pipe(catchError(this.handleError));
  }

  getLatestRepliesByCommentId(commentId: any, diff: any): Observable<any> {
    return this.http.get(`${this.url}comment/${commentId}/replies/latest/${diff}`)
      .pipe(catchError(this.handleError));
  }

  updateReply(replyData: any, type: any): Observable<any> {
    return this.http.put(`${this.url}reply/update/`, { replyData, type })
      .pipe(catchError(this.handleError));
  }

  deleteReply(id: any, type: any, postId: any, userId: any, isManager: any): Observable<any> {
    return this.http.delete(`${this.url}reply/delete/?id=${id}&type=${type}&postId=${postId}&userId=${userId}&isManager=${isManager}`)
      .pipe(catchError(this.handleError));
  }

  commentsLikes(commentsId: any, type: any, feedId: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('commentsId', commentsId);
    formData.append('userId', this.id);
    formData.append('feedType', type);
    formData.append('feedId', feedId);

    return this.http.put(`${this.url}comment/commentsUpvote/`, formData)
      .pipe(catchError(this.handleError));
  }

  replyLikes(replyId: any, type: any, feedId: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('replyId', replyId);
    formData.append('userId', this.id);
    formData.append('feedType', type);
    formData.append('feedId', feedId);

    return this.http.put(`${this.url}reply/replyUpvote/`, formData)
      .pipe(catchError(this.handleError));
  }

  flagCommentById(commentId: any, userId: any, type: any, isManager: any, flagType: any, postId: any): Observable<any> {
    return this.http.put(`${this.url}comments/${commentId}/flag/${userId}`, { type, isManager, flagType, postId })
      .pipe(catchError(this.handleError));
  }

  flagReplyById(replyId: any, userId: any, type: any, isManager: any, flagType: any, postId: any): Observable<any> {
    return this.http.put(`${this.url}reply/${replyId}/flag/${userId}`, { type, isManager, flagType, postId })
      .pipe(catchError(this.handleError));
  }

  getFlaggedCommentByUserId(userId: any): Observable<any> {
    return this.http.get(`${this.url}user/${userId}/comments/flagged`)
      .pipe(catchError(this.handleError));
  }

  getFlaggedReplyByUserId(userId: any): Observable<any> {
    return this.http.get(`${this.url}user/${userId}/reply/flagged`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<any> {
    console.error('An error occurred:', error);
    return throwError(error); // Throw error back to the caller
  }
}
